import React, { useState } from 'react';
import { Box, Button, Typography, Switch, FormControlLabel, Paper } from '@mui/material';
import TopicsDialog from '../components/layout/TopicsDialog';

const TopicsDialogDemo = () => {
  const [open, setOpen] = useState(false);
  const [showTopics, setShowTopics] = useState(false);
  
  // Sample topics that would be shown if available
  const sampleTopics = [
    { id: 1, title: 'API Guidelines' },
    { id: 2, title: 'Security Guidelines' },
    { id: 3, title: 'Field Validation' },
    { id: 4, title: 'Technology Stack' }
  ];

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddTopics = () => {
    // In a real implementation, this would save the selected topics
    console.log('Adding topics');
    handleClose();
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>Topics Dialog Demo</Typography>
      
      <Paper elevation={2} sx={{ p: 3, mb: 4, maxWidth: 500 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Dialog Settings</Typography>
        
        <FormControlLabel
          control={
            <Switch 
              checked={showTopics}
              onChange={() => setShowTopics(!showTopics)}
            />
          }
          label="Show sample topics (toggle off to see 'No task to select' message)"
        />
        
        <Box sx={{ mt: 3 }}>
          <Button 
            variant="contained" 
            onClick={handleOpen}
            sx={{ bgcolor: '#485869' }}
          >
            Open Topics Dialog
          </Button>
        </Box>
      </Paper>
      
      <TopicsDialog 
        open={open} 
        onClose={handleClose}
        topics={showTopics ? sampleTopics : []}
        onAddTopics={handleAddTopics}
      />
    </Box>
  );
};

export default TopicsDialogDemo;